namespace Matrix.Rebalancer {
    export interface TradeMacroAssignmentForm {
        AccountCode: FormatServiceLookupEditor;
        CashflowType: Serenity.StringEditor;
        Macro1: Serenity.LookupEditor;
        Macro2: Serenity.LookupEditor;
        Macro3: Serenity.LookupEditor;
        Macro4: Serenity.LookupEditor;
        Macro5: Serenity.LookupEditor;
        Macro6: Serenity.LookupEditor;
        Macro7: Serenity.LookupEditor;
        Macro8: Serenity.LookupEditor;
        Macro9: Serenity.LookupEditor;
        Macro10: Serenity.LookupEditor;
        Macro11: Serenity.LookupEditor;
        Macro12: Serenity.LookupEditor;
        Macro13: Serenity.LookupEditor;
        Macro14: Serenity.LookupEditor;
        Macro15: Serenity.LookupEditor;
        Macro16: Serenity.LookupEditor;
        Macro17: Serenity.LookupEditor;
        Macro18: Serenity.LookupEditor;
        Macro19: Serenity.LookupEditor;
        Macro20: Serenity.LookupEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class TradeMacroAssignmentForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.TradeMacroAssignment';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TradeMacroAssignmentForm.init)  {
                TradeMacroAssignmentForm.init = true;

                var s = Serenity;
                var w0 = FormatServiceLookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.LookupEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(TradeMacroAssignmentForm, [
                    'AccountCode', w0,
                    'CashflowType', w1,
                    'Macro1', w2,
                    'Macro2', w2,
                    'Macro3', w2,
                    'Macro4', w2,
                    'Macro5', w2,
                    'Macro6', w2,
                    'Macro7', w2,
                    'Macro8', w2,
                    'Macro9', w2,
                    'Macro10', w2,
                    'Macro11', w2,
                    'Macro12', w2,
                    'Macro13', w2,
                    'Macro14', w2,
                    'Macro15', w2,
                    'Macro16', w2,
                    'Macro17', w2,
                    'Macro18', w2,
                    'Macro19', w2,
                    'Macro20', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
